import { render, staticRenderFns } from "./BookshelfPage.vue?vue&type=template&id=7fcf9bfe&scoped=true&"
import script from "./BookshelfPage.vue?vue&type=script&lang=js&"
export * from "./BookshelfPage.vue?vue&type=script&lang=js&"
import style0 from "./BookshelfPage.vue?vue&type=style&index=0&id=7fcf9bfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcf9bfe",
  null
  
)

export default component.exports